import { Link } from "react-router-dom";
import type { HelpCenterAudience } from "../../interfaces/models/IHelpCenter";
import type { IHelpCenterSubSection } from "../../interfaces/models/IHelpCenter";
import { helpCenterCategoryPathWithSubSection } from "./helpCenterRoutes";

type HelpCenterSubSectionLinkProps = {
  audience: HelpCenterAudience;
  sectionId: string;
  subSection: IHelpCenterSubSection;
};

export default function HelpCenterSubSectionLink({
  audience,
  sectionId,
  subSection,
}: HelpCenterSubSectionLinkProps) {
  const target = helpCenterCategoryPathWithSubSection(
    audience,
    sectionId,
    subSection.id,
  );

  return (
    <Link to={target.pathname} state={target.state} className="help-center-link">
      {subSection.title}
    </Link>
  );
}
